var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.1314fe4ac2d712ab9d972f012b353419.svg#p';
                    var viewUrl = 'sprites.1314fe4ac2d712ab9d972f012b353419.svg#view-p';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 28',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };